import { CheckCircle2, X } from "lucide-react";

export default function PaymentComplete() {
  return (
    <section className="flex min-h-screen items-center justify-center bg-cream px-6 py-12">
      <div className="w-full max-w-sm rounded-3xl border border-ink/10 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-mint">
          <CheckCircle2 className="h-7 w-7 text-ink" />
        </div>
        <h1 className="mt-5 text-2xl font-black tracking-tight text-ink">
          Payment successful!
        </h1>
        <p className="mt-2 text-sm text-ink/60">
          We've sent your order confirmation on Instagram.
        </p>

        <div className="mt-6 flex items-center justify-center gap-2 rounded-2xl bg-ink/[0.03] px-4 py-3 text-sm font-semibold text-ink">
          <X className="h-4 w-4 text-ink/50" />
          Close this window to return to your chat
        </div>
      </div>
    </section>
  );
}